export default __webpack_public_path__ + "static/media/043-contract.74e5385f.svg";